export default __webpack_public_path__ + "static/media/visa-card.874e671f.svg";